import React from 'react'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const Text = (props) => {
  const [state, setState] = React.useState({words: "", sentenceIdx: 0})

  React.useEffect(() => {
    let cursor = props.cursor || ""
    let nextIcon = document.getElementById("next_icon")
    const typeSentence = (sentence, cursorPos = 1) => {
      return (() => {
        if (cursorPos < sentence.length) {
          setState({...state, words: sentence.slice(0, cursorPos++) + cursor})
        } else {
          setState({...state, words: sentence})
          clearInterval(typing)
          typing = false
          nextIcon.style.display = "block"
        }
      })
    }
    let typing = setInterval(typeSentence(props.texts[state.sentenceIdx], 1), 50)

    document.getElementById("texts_container").onclick = () => {
      if (typing) {
        let sentence = props.texts[state.sentenceIdx]
        setState({...state, words: sentence})
        clearInterval(typing)
        typing = false
        nextIcon.style.display = "block"
      } else {
        if (state.sentenceIdx + 1 < props.texts.length) {
          nextIcon.style.display = "none"
          setState({...state, sentenceIdx: state.sentenceIdx + 1})
        } else {
          props.onEnd()
        }
      }
    }

    return (() => {
      document.getElementById("texts_container").onclick = null
    })
  }, [state.sentenceIdx])

  React.useEffect(() => {
    let nextIcon = document.getElementById("next_icon")
    setInterval(() => {
      nextIcon.style.visibility = (nextIcon.style.visibility === "visible" ? "hidden" : "visible")
    }, 500)
  }, [])

  return (
    <div
      id="texts_container"
      style={{
        position: "absolute",
        display: "table",
        width: "90%",
        height: "inherit",
        left: "5%",
      }}
    >
      <div
        id="texts_overlay"
        style={{
          display: "table-cell",
          width: "100%",
          height: "100%",
          color: "White",
          fontSize: "3vh",
          textShadow: "1px 1px #333333",
          textAlign: "center",
          padding: "3vw 3vw",
          verticalAlign: "middle"
        }}
      >
        {state.words}
      </div>
      <div
        id="next_icon"
        style={{
          display: "none",
          position: "absolute",
          zIndex: "20",
          left: "0",
          bottom: "15vh",
          width: "100%",
          textAlign: "center",
          textShadow: "1px 1px #000000",
          color: "White",
          visibility: "visible"
        }}
      >
        <ArrowDropDownIcon fontSize="large" />
      </div>
    </div>
  )
}

export default Text
